/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Platforms_TitleInputs */

const en_directory_platforms_title = /** @type {(inputs: Directory_Platforms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find products for your platform`)
};

const zh_directory_platforms_title = /** @type {(inputs: Directory_Platforms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查找适合你平台的产品`)
};

/**
* | output |
* | --- |
* | "Find products for your platform" |
*
* @param {Directory_Platforms_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_platforms_title = /** @type {((inputs?: Directory_Platforms_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Platforms_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_platforms_title(inputs)
	return zh_directory_platforms_title(inputs)
});
export { directory_platforms_title as "directory.platforms.title" }